export default "__VITE_ASSET__BYa3Bfj___"